import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

const getUltimoBlog = async () => {
    const res = await fetch(`https://blog.ebmconsultores.com.mx/wp-json/wp/v2/posts?_embed&per_page=100&_=${Date.now()}`)
    const data = await res.json();
    const post = data[0];

    return {
        titulo: post.title.rendered,
        descripcion: post.excerpt.rendered.replace(/<[^>]+>/g, ''),
        enlace: post.link,
        imagen: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '/imagen-generica.jpg',
    };
};

export default function FeaturedPost() {
    const [blog, setBlog] = useState(null);

    useEffect(() => {
        getUltimoBlog().then(setBlog);
    }, []);

    if (!blog) return null;

    const maxWords = 35;
    const palabras = blog.descripcion.split(' ');
    const descripcionRecortada = palabras.slice(0, maxWords).join(' ');
    const isLongText = palabras.length > maxWords;

    return (
        <Box sx={{ position: 'relative', width: '100%', maxWidth: '1280px', mx: 'auto', px: { xs: 2, md: 0 } }}>
            {/* Imagen destacada */}
            <Box sx={{ position: 'relative', width: '100%' }}>
                <Box
                    component="a"
                    href={blog.enlace}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ display: 'block' }}
                >
                    <Box
                        component="img"
                        src={blog.imagen}
                        alt="Publicación destacada"
                        sx={{
                            width: '100%',
                            height: { xs: 'auto', md: '35vw' },
                            borderTopLeftRadius: { xs: '40px', md: '100px' },
                            borderTopRightRadius: { xs: '40px', md: 0 },
                            borderBottomRightRadius: { xs: '40px', md: '100px' },
                            display: 'block',
                            objectFit: 'cover'
                        }}
                    />
                </Box>

                {/* Blur superpuesto con scroll solo en mobile */}
                <Box
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        right: 0,
                        left: 'auto',
                        width: { xs: '250px', md: '586px' },
                        height: { xs: '120px', md: '200px' },
                        overflowY: { xs: 'auto', md: 'visible' },
                        WebkitOverflowScrolling: 'touch',
                        background: 'rgba(0, 0, 0, 0.6)',
                        backdropFilter: 'blur(6px)',
                        WebkitBackdropFilter: 'blur(6px)',
                        color: 'white',
                        p: { xs: 1.5, md: 4 },
                        pt: { xs: 2, md: 0 },
                        mt: { xs: 5, md: 0 },
                        borderBottomRightRadius: { xs: '30px', md: '90px', xl: '100px' },
                        borderTopLeftRadius: { xs: '30px', md: '100px' },
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        gap: { xs: 0.5, md: 2 },
                        boxShadow: {
                            xs: '0px 0px 10px rgba(0,183,255,0.3)',
                            md: 'inset 0 0 0 1px rgba(255,255,255,0.15)',
                        },
                        border: {
                            xs: '1px solid rgba(0, 183, 255, 0.3)',
                            md: '1px solid rgba(0, 183, 255, 0.6)',
                        },
                        zIndex: 1,
                    }}
                >
                    <Typography
                        variant="h6"
                        component="a"
                        href={blog.enlace}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            fontWeight: 700,
                            fontSize: { xs: '14px', md: '16px' },
                            fontFamily: 'Poppins, sans-serif',
                            color: 'white',
                            textDecoration: 'none',
                            wordBreak: 'break-word',
                            lineHeight: 1.2,
                            mt: { xs: 1.5, sm: 2, md: 6 }, // ← AQUI el espaciado hacia abajo
                            '&:hover': { textDecoration: 'underline' },
                        }}
                    >
                        {blog.titulo}
                    </Typography>


                    <Typography
                        variant="body2"
                        sx={{
                            fontSize: { xs: '11px', sm: '13px', md: '14px' },
                            lineHeight: 1.4,
                            fontFamily: 'Poppins, sans-serif',
                        }}
                    >
                        {descripcionRecortada}...
                        {isLongText && (
                            <Box
                                component="a"
                                href={blog.enlace}
                                target="_blank"
                                rel="noopener noreferrer"
                                sx={{
                                    color: '#00B7FF',
                                    ml: 1,
                                    fontWeight: 'bold',
                                    fontSize: '12px',
                                    textDecoration: 'underline',
                                    '&:hover': { color: '#33c5ff' }
                                }}
                            >
                                Leer más
                            </Box>
                        )}
                    </Typography>
                </Box>
            </Box>

            {/* Cinta NUEVA PUBLICACIÓN */}
            <Box sx={{
                position: 'absolute',
                top: { xs: '10px', md: '40px' },
                left: { xs: '16px', md: '-130px', xl: '-400px' },
                width: { xs: 'auto', md: '450px', xl: '750px' },
                height: { xs: '28px', md: '51px' },
                px: { xs: 2, md: 3 },
                pl: { xs: 4, md: 20, xl: 50 },
                background: 'linear-gradient(to right, #38383D 39%, #0A6274 100%)',
                color: 'white',
                fontFamily: 'Poppins, sans-serif',
                fontWeight: 'bold',
                fontSize: { xs: '11px', md: '24px' },
                textTransform: 'uppercase',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                borderTopRightRadius: '30px',
                borderBottomRightRadius: '30px',
                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4)',
                zIndex: 2,
            }}>
                NUEVA PUBLICACIÓN
            </Box>
        </Box>
    );
}
